import { IdentityVerificationStatus } from '@40seas/entities/common';
import { IntentStatus } from '@40seas/entities/intents';
import { EnumColor } from '@40seas/frontend/common/providers';

export const identityVerificationStatusColorMapping = {
    [IdentityVerificationStatus.Verified]: 'success',
    [IdentityVerificationStatus.InProgress]: 'info',
    [IdentityVerificationStatus.Failed]: 'error',
} as { [key in IdentityVerificationStatus]: EnumColor };
